// import React from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import userAPI from "../../api/UserApi";
// import { clearAccessToken } from "../../api/axiosInstance";
// import { motion } from "framer-motion";
// import {
//   Flame,
//   Package,
//   Settings,
//   ChevronRight,
// } from "lucide-react";


// const navItems = [
//   { id: "overview", label: "My Spice Shelf", icon: Flame },
//   { id: "orders", label: "Order History", icon: Package },
//   { id: "settings", label: "Account Settings", icon: Settings },
//   { id: "changepassword", label: "Change Passworc", icon: Settings },
// ];

// function Sidebar({ activeTab, setActiveTab }) {
//   const navigate = useNavigate();

//   const logOut = async () => {
//     try {
//       await userAPI.logOut();

//       clearAccessToken();
//       localStorage.removeItem("token");
//       localStorage.removeItem("accessToken");

//       navigate("/");
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <motion.div
//       initial={{ x: -24, opacity: 0 }}
//       animate={{ x: 0, opacity: 1 }}
//       transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
//       style={{
//         position: "sticky",
//         top: 84,
//         display: "flex",
//         flexDirection: "column",
//         gap: 10,
//       }}
//     >
//       {/* Profile card */}
//       <div className="acc-profile">
//         <div className="acc-banner">
//           <div className="acc-avatar-wrap">
//             <img
//               src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80"
//               alt="User"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover",
//               }}
//             />
//           </div>
//         </div>
//         <div
//           style={{
//             paddingTop: 44,
//             paddingBottom: 18,
//             paddingLeft: 18,
//             paddingRight: 18,
//             textAlign: "center",
//           }}
//         >
//           <h2
//             style={{
//               fontFamily: "var(--font-logo)",
//               fontSize: "1.25rem",
//               color: "var(--color-text-primary)",
//               letterSpacing: "-0.01em",
//               marginBottom: 2,
//             }}
//           >
//             Priya Sharma
//           </h2>
//           <span
//             style={{
//               fontFamily: "var(--font-accent)",
//               fontSize: "0.95rem",
//               color: "var(--color-primary)",
//               opacity: 0.75,
//             }}
//           >
//             Spice Connoisseur
//           </span>

//           {/* Loyalty */}
//           <div
//             style={{
//               marginTop: 14,
//               background: "var(--bg-secondary)",
//               border: "1px solid var(--card-border)",
//               borderRadius: 4,
//               padding: "10px 12px",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginBottom: 5,
//               }}
//             >
//               <span
//                 style={{
//                   fontFamily: "var(--font-subheading)",
//                   fontSize: "0.52rem",
//                   fontWeight: 700,
//                   letterSpacing: "0.16em",
//                   textTransform: "uppercase",
//                   color: "var(--color-text-muted)",
//                 }}
//               >
//                 Masala Club
//               </span>
//               <span
//                 style={{
//                   fontFamily: "var(--font-subheading)",
//                   fontSize: "0.52rem",
//                   fontWeight: 700,
//                   color: "var(--color-primary)",
//                 }}
//               >
//                 Gold
//               </span>
//             </div>
//             <div className="acc-bar-track">
//               <div className="acc-bar-fill" style={{ width: "68%" }} />
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginTop: 4,
//               }}
//             >
//               <span
//                 style={{
//                   fontFamily: "var(--font-subheading)",
//                   fontSize: "0.5rem",
//                   color: "var(--color-text-muted)",
//                 }}
//               >
//                 680 pts
//               </span>
//               <span
//                 style={{
//                   fontFamily: "var(--font-subheading)",
//                   fontSize: "0.5rem",
//                   color: "var(--color-text-muted)",
//                 }}
//               >
//                 320 to Platinum
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Nav */}
//         <div
//           style={{
//             padding: "0 10px 14px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 4,
//           }}
//         >
//           {navItems.map((item) => (
//             <button
//               key={item.id}
//               className={`acc-nav ${activeTab === item.id ? "active" : ""}`}
//               onClick={() => setActiveTab(item.id)}
//             >
//               <item.icon size={14} style={{ flexShrink: 0 }} />
//               {item.label}
//               {activeTab === item.id && (
//                 <ChevronRight
//                   size={11}
//                   style={{ marginLeft: "auto", opacity: 0.7 }}
//                 />
//               )}
//             </button>
//           ))}

//           <button onClick={logOut}>
//             Logout
//           </button>
//         </div>
//       </div>

//       {/* Quick stats */}
//       <div className="acc-card" style={{ display: "flex" }}>
//         {[
//           { val: "18", label: "Orders" },
//           { val: "5", label: "Saved" },
//           { val: "4.9", label: "Rating" },
//         ].map((s) => (
//           <div key={s.label} className="acc-stat">
//             <span
//               style={{
//                 fontFamily: "var(--font-logo)",
//                 fontSize: "1.15rem",
//                 color: "var(--color-primary)",
//                 lineHeight: 1,
//               }}
//             >
//               {s.val}
//             </span>
//             <span
//               style={{
//                 fontFamily: "var(--font-subheading)",
//                 fontSize: "0.48rem",
//                 letterSpacing: "0.14em",
//                 textTransform: "uppercase",
//                 color: "var(--color-text-muted)",
//                 marginTop: 3,
//               }}
//             >
//               {s.label}
//             </span>
//           </div>
//         ))}
//       </div>
//     </motion.div>
//   );
// }

// export default Sidebar;



import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  Package,
  Settings,
  Flame,
  MapPin,
  KeyRound,
  LogOut,
  ChevronRight,
} from "lucide-react";
import userAPI from "../../api/UserApi";
import { clearAccessToken } from "../../api/axiosInstance";

const navItems = [
  { id: "overview", label: "Dashboard", icon: Flame },
  { id: "orders", label: "My Orders", icon: Package },
  { id: "addresses", label: "Addresses", icon: MapPin },
  { id: "settings", label: "Account Details", icon: Settings },
  { id: "changePassword", label: "Change Password", icon: KeyRound },
];

function Sidebar({ activeTab, setActiveTab, user, loadingUser }) {
  const navigate = useNavigate();

  const displayName = loadingUser
    ? "..."
    : [user?.firstName, user?.lastName].filter(Boolean).join(" ") || "Guest";

  const logOut = async () => {
    try {
      await userAPI.logOut();
    } catch (err) {
      console.log(err);
    } finally {
      clearAccessToken();
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");
      navigate("/");
    }
  };

  return (
    <motion.div
      initial={{ x: -24, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
      className="sticky top-0 flex flex-col gap-2.5"
    >
      {/* Profile card */}
      <div className="acc-profile overflow-hidden rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-white)] shadow-[var(--shadow-sm)]">
        {/* <div className="acc-banner relative h-[76px] bg-gradient-to-br from-[var(--color-primary-dark)] to-[var(--color-primary-light)]">
          <div className="acc-avatar-wrap absolute left-1/2 -bottom-[34px] h-[68px] w-[68px] -translate-x-1/2 overflow-hidden rounded-full border-[3px] border-[var(--color-white)] shadow-[var(--shadow-md)]">
            <img
              src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80"
              alt="User"
              className="h-full w-full object-cover"
            />
          </div>
        </div> */}

        <div className="px-[18px] pt-11 pb-[18px] text-center">
          <h2 className="mb-0.5 font-heading text-[1.25rem] tracking-[-0.01em] text-[var(--color-text)]">
            {displayName}
          </h2>
        </div>

        {/* Nav */}
        <div className="flex flex-col gap-1 px-2.5 pb-3.5">
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`acc-nav ${activeTab === item.id ? "active" : ""}`}
              onClick={() => setActiveTab(item.id)}
            >
              <item.icon size={14} className="flex-shrink-0" />
              {item.label}
              {activeTab === item.id && (
                <ChevronRight size={11} className="ml-auto opacity-70" />
              )}
            </button>
          ))}

          <button className="acc-nav acc-nav-logout" onClick={logOut}>
            <LogOut size={14} className="flex-shrink-0" />
            Logout
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default Sidebar;